import type { Dict } from './deepMerge';

/**
 * Loads one language's (English-merged) translations on demand.
 *
 * Every language used to be imported statically into the client bundle, so a
 * visitor on any page downloaded and parsed all six — about 1 MB of JavaScript,
 * 306 kB gzipped, most of it text in languages they never see — before the page
 * could hydrate. Each loader below is a separate import() call, so the bundler
 * emits each language as its own chunk.
 *
 * The page's own language reaches the client from the server layout as a prop
 * (see app/(main)/[lang]/layout.tsx), so the first render and hydration are
 * synchronous and identical to the prerendered HTML. These loaders are only
 * called again when someone switches language in the browser.
 */
const LOADERS: Record<string, () => Promise<{ default: unknown }>> = {
  en: () => import('./merged/en'),
  fi: () => import('./merged/fi'),
  sv: () => import('./merged/sv'),
  da: () => import('./merged/da'),
  de: () => import('./merged/de'),
  pl: () => import('./merged/pl'),
};

export async function loadTranslation(lang: string): Promise<Dict> {
  const load = LOADERS[lang] ?? LOADERS.en;
  return (await load()).default as Dict;
}
